import "@/App.css";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Nav, Footer } from "./components";
import { HomePage, ProductDetailPage, MirrorLotusPage, SessionDetailPage, AboutPage } from "./pages";
import { AdminPage } from "./admin";
import { CopyrightPage, TermsPage, PrivacyPage } from "./legal";
import { FinancialFreedomExperience, LoveConnectionExperience, SixColorCompleteExperience, DreamConnectionExperience } from "./experience";
import PrintExperience from "./print";
import { CardDownloadPage, ArtworkPrintPage, MeaningPrintPage } from "./card-purchase";

function NotFoundPage() {
  return (
    <section className="min-h-screen flex flex-col items-center justify-center px-6 text-center" data-testid="page-not-found">
      <div className="text-[10px] tracking-[0.4em] uppercase text-[#B58B2E] mb-4">Page Not Found</div>
      <h1 className="display-serif text-4xl sm:text-5xl mb-4 text-[#F5D48A]">This page has drifted.</h1>
      <p className="text-[#F2EFE8]/70 max-w-md mb-8">
        The link you followed doesn't exist here — the URL may be mistyped, or the page has moved.
      </p>
      <Link to="/" className="btn-gold" data-testid="not-found-home-btn">Return Home</Link>
    </section>
  );
}

function App() {
  return (
    <HelmetProvider>
      <div className="App sf-velvet min-h-screen relative" data-testid="home-page">
        <BrowserRouter>
          <Nav />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/snapshots/:slug" element={<ProductDetailPage />} />
            <Route path="/mirror-lotus" element={<MirrorLotusPage />} />
            <Route path="/sessions/:slug" element={<SessionDetailPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/copyright" element={<CopyrightPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/experience/financial-freedom" element={<FinancialFreedomExperience />} />
            <Route path="/experience/love-connection" element={<LoveConnectionExperience />} />
            <Route path="/experience/six-color-complete" element={<SixColorCompleteExperience />} />
            <Route path="/experience/dream-connection" element={<DreamConnectionExperience />} />
            <Route path="/print/:slug" element={<PrintExperience />} />
            <Route path="/download/card/:token" element={<CardDownloadPage />} />
            <Route path="/download/card/:token/artwork" element={<ArtworkPrintPage />} />
            <Route path="/download/card/:token/meaning" element={<MeaningPrintPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
          <Footer />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
